import React from 'react';
import { Link } from 'react-router-dom';
import { toIdentifierMask } from '../../services/mask';
import EstimateStatusBadge from '../../components/EstimateStatus/EstimateStatusBadge';
import { EstimateModel } from './EstimatesIndex';
import EstimateTagBadge from '../../components/Estimate/EstimateTagBadge';

interface EstimatesListProps {
  estimates: EstimateModel[];
}

export default function EstimatesList({ estimates }: EstimatesListProps) {
  function formatCell(
    top: JSX.Element | string,
    bottom: JSX.Element | string = ''
  ) {
    return (
      <div className='d-flex flex-column'>
        <div>{top}</div>
        {bottom ? (
          <div>
            <small className='text-muted'>{bottom}</small>
          </div>
        ) : undefined}
      </div>
    );
  }

  return (
    <table className='table table-hover'>
      <thead>
        <tr>
          <th scope='col'>#</th>
          <th scope='col'>Data</th>
          <th scope='col'>Empresa</th>
          <th scope='col'>Cliente</th>
          <th scope='col'>Natureza da Op.</th>
          <th scope='col'>Status</th>
          <th scope='col'>Etiquetas</th>
        </tr>
      </thead>
      <tbody>
        {estimates.map((i) => {
          const createdAt = new Date(i.createdAt);
          const editLink = (
            <Link to={`/estimates/${i.id}/edit`}>{i.number || '#'}</Link>
          );
          return (
            <tr key={i.id}>
              <th scope='row'>{formatCell(editLink)}</th>
              <td>
                {formatCell(
                  createdAt.toLocaleDateString(),
                  createdAt.toLocaleTimeString()
                )}
              </td>
              <td>
                {formatCell(
                  i.companyName,
                  toIdentifierMask(i.companyIdentifier, i.companyType)
                )}
              </td>
              <td>
                <Link to={`/estimates/${i.id}/edit`}>
                  {formatCell(
                    i.customerName,
                    toIdentifierMask(i.customerIdentifier, i.customerType)
                  )}
                </Link>
              </td>
              <td>{i.transactionNatureName}</td>
              <td>
                <EstimateStatusBadge status={i.status} />
              </td>
              <td>
                <div className='mt-1 d-flex gap-1 flex-wrap'>
                  {i.estimateTags &&
                    i.estimateTags.map((t) => {
                      return (
                        <EstimateTagBadge key={t.tagId} tag={t} isCollapsable />
                      );
                    })}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
